import { render, staticRenderFns } from "./envelope-list.vue?vue&type=template&id=3a29cf6a&scoped=true"
import script from "./envelope-list.vue?vue&type=script&lang=js"
export * from "./envelope-list.vue?vue&type=script&lang=js"
import style0 from "./envelope-list.vue?vue&type=style&index=0&id=3a29cf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a29cf6a",
  null
  
)

export default component.exports